import axios from "axios"
import getBearToken, { isTokenExpired } from "pages/Utility/token";

//apply base url for axios
export const API_URL = "https://admin-server.veeperapp.com/api/v1"

// export const API_URL = "http://localhost:3101/api/v1"

const axiosApi = axios.create({
    baseURL: API_URL,
});

// Attach the token fresh on every request so login/logout changes are picked up
axiosApi.interceptors.request.use(config => {
    if (isTokenExpired()) {
        localStorage.removeItem("veeperAuthToken")
        localStorage.removeItem("authUser")
        window.location.href = "/login"
        return Promise.reject(new Error("Session expired"))
    }
    const token = getBearToken()
    if (token) {
        config.headers["Authorization"] = token
    }
    return config
})

axiosApi.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem("veeperAuthToken")
            localStorage.removeItem("authUser")
            window.location.href = "/login"
        }
        return Promise.reject(error)
    }
)

export async function get(url, config = {}) {
    return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then(response => response.data)
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then(response => response.data)
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then(response => response.data)
}

